import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/Seo"

const NotFoundPage = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title

  return (
    <Layout location={location} title={siteTitle}>
      <Seo title="404: Non trovato" />
      <h1>404: pagina non trovata</h1>
      <p>
        Opss, ci dispiace, la pagina cercata non esiste, forse è stata rimossa o
        ha cambiato indirizzo,,,
      </p>
    </Layout>
  )
}

export default NotFoundPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
